// extracted by mini-css-extract-plugin
export default {"legalFooter":"LegalFooter_legalFooter__YnN8R","build":"LegalFooter_build__8O9Ef"};